module.exports = __webpack_public_path__ + "img/Crownhill_Finished.e83bbb6a.jpg";